<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_309_7533)">
      <path
        d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433281 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM14 16.92V15C13.9964 14.2818 13.7995 13.5778 13.43 12.962C13.0605 12.3461 12.532 11.8411 11.9 11.5C12.6845 11.078 13.3057 10.4061 13.6651 9.591C14.0245 8.77587 14.1014 7.86411 13.8838 7.00026C13.6662 6.13642 13.1665 5.36993 12.4638 4.82233C11.7612 4.27474 10.8958 3.97736 10.005 3.97736C9.11417 3.97736 8.24883 4.27474 7.54618 4.82233C6.84353 5.36993 6.34379 6.13642 6.12618 7.00026C5.90857 7.86411 5.98556 8.77587 6.34493 9.591C6.7043 10.4061 7.32549 11.078 8.11 11.5C7.47613 11.8398 6.9456 12.3442 6.57428 12.9602C6.20295 13.5761 6.00457 14.2808 6 15V16.92C4.47487 16.0395 3.2829 14.6803 2.60897 13.0533C1.93503 11.4262 1.8168 9.62231 2.2726 7.92124C2.7284 6.22018 3.73276 4.71704 5.12991 3.64497C6.52707 2.5729 8.23893 1.9918 10 1.9918C11.7611 1.9918 13.4729 2.5729 14.8701 3.64497C16.2673 4.71704 17.2716 6.22018 17.7274 7.92124C18.1832 9.62231 18.065 11.4262 17.391 13.0533C16.7171 14.6803 15.5251 16.0395 14 16.92Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_309_7533">
        <rect width="20" height="20" fill="currentColor" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Avatar',
} as DefineComponent
</script>
